import CssBaseline from '@mui/material/CssBaseline'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'

import './mordred.css'

export default function Home() {
  return (
    <>
      <CssBaseline />

      <Container maxWidth="xl">
        <div className="jumbotron">
          <h1>Monty Taylor</h1>
        </div>
        <Box>Things you may or may not care or not care about.</Box>
        <Box sx={{ mt: 2 }}>
          <a href="/talks/">Slides for talks I&apos;ve given</a>
        </Box>
        <Box>
          <a href="/posts/">Thoughts</a>
        </Box>
        <Box>
          <a href="/resume/">Resume</a>
        </Box>
      </Container>
    </>
  )
}
